import * as React from 'react';
import { SwitchTransition, CSSTransition } from 'react-transition-group';

import { classNames } from './FadeInOut.stylesheet';

interface Props {
  children: React.ReactNode;
  transitionKey: string;
}

export default function FadeInOut({ children, transitionKey }: Props) {
  return (
    <SwitchTransition>
      <CSSTransition key={transitionKey} timeout={350} classNames={classNames}>
        <div>{children}</div>
      </CSSTransition>
    </SwitchTransition>
  );
}
